var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation-requirement__container"},[_c('div',{class:("validation-indicator_" + _vm.stringState)}),_c('div',{class:("validation-requirement__text_" + _vm.stringState)},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }